import { LOADING } from "../../../constants/constant";
import {
  INVITE_USER_FAILED,
  INVITE_USER_REQUESTED,
  INVITE_USER_RESET,
  INVITE_USER_SUCCESS,
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: undefined,
};

export default function getInviteUserReducer(state = initialState, action) {
  switch (action.type) {
    case INVITE_USER_REQUESTED:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case INVITE_USER_SUCCESS:
      let userRes = Object.assign({}, state);
      console.log(
        "Invite user reducer => Case => Success: while getting category list: " +
          JSON.stringify(action.data)
      );
      userRes.status = action.data.status_message;
      userRes.statusCode = action.data.status_code;
      userRes.isLoading = false;
      userRes.message = action.data.message;
      userRes.data = action.data.data;

      return userRes;

    case INVITE_USER_FAILED:
      console.error(
        "Invite User Reducer => Case => Error: while getting category list: " +
          JSON.stringify(action.error)
      );
      return Object.assign({}, state, action.error);

    case INVITE_USER_RESET: {
      return initialState;
    }

    default:
      return state;
  }
}
